import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { useAttachmentSignedUrl } from 'hooks/useAttachmentSignedUrl';
import Attachment from 'models/Attachment';
import { colors } from 'styles/theme/colors';

import LazyImage from './LazyImage';
import StandardModal from './StandardModal';

type ImageViewerInput = {
  attachment: Attachment;
  onClose?: () => void;
  show: boolean;
};

export default function ImageViewer(props: ImageViewerInput) {
  const { attachment, onClose, show } = props;

  // The signed URL expires ~30s after issue, so fetch a fresh one every time
  // the modal opens (staleTime: 0) and never render a cached URL while the
  // refetch is in flight — it may already be expired.
  const {
    data: fullAttachment,
    isFetching,
    isError,
  } = useAttachmentSignedUrl(attachment.id, undefined, { enabled: show, staleTime: 0 });

  const [imageLoaded, setImageLoaded] = useState(false);
  return (
    show && (
      <StandardModal title='Attached Image' onCancel={onClose}>
        <ImageContainer $imageLoaded={imageLoaded}>
          {isError ? (
            <ErrorMessage>Unable to load this image. Please close and try again.</ErrorMessage>
          ) : (
            <LazyImage
              src={isFetching ? '' : (fullAttachment?.url ?? '')}
              customStyles={{ maxWidth: '100%' }}
              alt='attached image'
              onLoaded={setImageLoaded}
              useSpinner
            />
          )}
        </ImageContainer>
      </StandardModal>
    )
  );
}

const ErrorMessage = styled.div`
  padding: 16px;
  color: ${colors.black50};
  font-size: 14px;
`;

const ImageContainer = styled.div<{ $imageLoaded: boolean }>`
  display: flex;
  margin: auto;
  max-width: 10vw;
  max-height: 10vw;
  overflow: auto;
  padding: 16px;

  ${({ $imageLoaded }) =>
    $imageLoaded &&
    css`
      max-width: 60vw;
      max-height: 40vw;
      transition: all 0.5s linear;
    `};

  /*
        Set margin on the children to fix issue
        with centering & scrolling larger images
    */
  & > * {
    margin: auto;
  }
`;
